import React from 'react'
import styled from 'styled-components'
// import { Helmet } from 'react-helmet'
import Head from 'next/head'
import Icon from '../components/Icon'
import Text from '../components/UI/Text'
import OurStory from '../components/AboutUs/OurStory'
import Founders from '../components/AboutUs/Founder'
import ImgCdn from '../components/shared/ImgCdn'
import { HEADER_HEIGHT } from '~/components/UI/Constants'
import { useTranslation } from '~/i18n'

const ArticleWrapper = styled.article`
  line-height: 1.5;
  margin-top: 50px;
  padding: 0 15px 0 15px;
`
const LargeHeader = styled.h4`
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.41;
  letter-spacing: -0.1px;
  color: #172b4d;
`
const HeadText = styled.h3`
  font-size: 16px;
  color: #1a1a1a;
  display: inline-block;
  margin-top: 30px;
`
const FounderContainer = styled.div`
  @media (min-width: 768px) {
    justify-content: center !important;
  }
`
const FounderName = styled.span`
  font-weight: bold;
  color: #172b4d;
  font-size: 16px;
`
const FounderImg = styled.img``
const TextIntro = styled.p`
  padding-left: 0 !important;
`
const Background = styled.div`
  background-color: rgba(235, 243, 255, 0.4);
`
const AboutUs = () => {
  const [t] = useTranslation()
  return (
    <div style={{ paddingTop: HEADER_HEIGHT }} key="about-us">
      <ArticleWrapper>
        <Head>
          <title>{t`Về Chúng Tôi`}</title>
          <meta name="description" content={t`Giới thiệu về Infina`} />
        </Head>

        <div className="container paragraphs">
          <div className="row">
            <div className="clearfix">
              <ImgCdn className="img-fluid float-left col-md-6 col-12 mr-3" src="/about/first.png" />
              <HeadText>{t`Tầm nhìn và sứ mệnh`}</HeadText>
              <LargeHeader>{t`Chúng tôi hướng tới một tương lai nơi mà ai cũng có thể tham gia vào lĩnh vực đầu tư`}</LargeHeader>
              <TextIntro>
                {t`Khởi đầu từ việc nhận thức được nhu cầu đầu tư của đại bộ phận dân số, nhưng lại thiếu đi những lựa chọn đầu tư với những khoản tiền nhỏ linh hoạt, chúng tôi đã quyết tâm thay đổi hiện thực này và đã quyết định đó cũng chính là sứ mệnh của Infina.`}
              </TextIntro>
            </div>
          </div>
          <div className="row mt-5">
            <div className="clearfix">
              <div className="clearfix text-center">
                <HeadText>{t`Sự Khởi Nguồn`}</HeadText>
              </div>
              <LargeHeader className="text-center">{t`Câu chuyện của chúng tôi`}</LargeHeader>
              <div className="row justify-content-center align-items-center">
                <OurStory />
              </div>
            </div>
          </div>
        </div>
        <Background className="container-fluid mt-5">
          <div className="container pt-5 pb-5">
            <div className="row mt-5">
              <div className="clearfix">
                <ImgCdn className="img-fluid float-right col-md-6 col-12 mt-3" src="/about/second.jpeg" />
                <LargeHeader>{t`Mô hình đầu tư và tích lũy thời đại 4.0`}</LargeHeader>
                <TextIntro className="col-md-6 ml-0">
                  <p>
                    {t(
                      'Infina là tên gọi của nền tảng đầu tư và tích lũy được sở hữu bởi công ty RealStake (RealStake Pte. Ltd). Được thành lập vào năm 2018 tại Singapore và có chi nhánh tại Việt Nam, đội ngũ chúng tôi bao gồm những chuyên gia hàng đầu với nhiều năm kinh nghiệm trong lĩnh vực BĐS, Tài Chính và Công Nghệ Thông Tin.'
                    )}
                  </p>
                  <p>{t`Chúng tôi định hướng theo mô hình công ty công nghệ, tức là sử dụng công nghệ để tạo ra sự đột phá cho thị trường nhằm đem lại lợi ích cho những nhà đầu tư. Tương tự như những gì Grab, Uber đã đem lại cho ngành vận tải hành khách, hay AirBnB cho ngành khách sạn, chúng tôi mong rằng Infina sẽ đem lại nhiều lợi ích cho mọi người.`}</p>
                </TextIntro>
              </div>
            </div>
          </div>
        </Background>

        <div className="container mt-5">
          <Text style={{ textAlign: 'center' }}>{t`Con người của RealStake`}</Text>
          <LargeHeader className="text-center mb-5">{t`Đội Ngũ Lãnh Đạo`}</LargeHeader>
          <FounderContainer className="row clearfix">
            {Founders.map((item) => {
              return (
                <div key={item.name} className="col-md-4 col-6 mb-5">
                  <FounderImg
                    className="img-fluid img-responsive img-rounded mb-2"
                    src={item.imgProfile}
                    alt={item.name}
                  />
                  <FounderName className="mr-0">
                    {item.name}
                    {item.linkedin && (
                      <a target="_blank" rel="noopener noreferrer" className="ml-2" href={item.linkedin}>
                        <Icon name="linkedin" />
                      </a>
                    )}
                  </FounderName>
                  <div>{item.role}</div>
                </div>
              )
            })}
          </FounderContainer>
        </div>
        <Background className="container-fluid mt-5">
          <div className="container pt-5 pb-5">
            <div className="row mb-5">
              <div className="clearfix">
                <ImgCdn className="img-fluid float-left col-md-6 col-12 mr-3" src="/about/team.jpg" />
                <HeadText>{t`Tuyển Dụng`}</HeadText>
                <LargeHeader>{t`Tham gia cách mạng hóa lĩnh vực đầu tư cùng Infina`}</LargeHeader>
                <TextIntro>
                  <p>{t`Để hướng tới một tương lai nơi mà ai cũng có thể tham gia đầu tư, chúng tôi luôn chào đón những con người tài năng để tham gia vào đội ngũ của mình.`}</p>
                  <p>{t`Hãy tham gia với chúng tôi ngay hôm nay và trở thành một phần quan trọng của sự thay đổi lớn.`}</p>
                </TextIntro>
                <a href="https://realstake.freshteam.com/jobs/" rel="nofollow noopener noreferrer" target="_blank">
                  {t`Xem chi tiết`} &gt;
                </a>
              </div>
            </div>
          </div>
        </Background>
      </ArticleWrapper>
    </div>
  )
}
AboutUs.getInitialProps = async () => ({
  namespacesRequired: ['common'],
})

export default AboutUs
